

/*
 * Copyright (c) 2021.
 * Simon
 */

export const SEGMENT_DETAIL_REQUEST = 'SEGMENT_DETAIL_REQUEST';
export const SEGMENT_DETAIL_SUCCESS = 'SEGMENT_DETAIL_SUCCESS';
export const SEGMENT_DETAIL_FAILURE = 'SEGMENT_DETAIL_FAILURE';

